import React, { useState } from "react";
import Button from "../Buttons/Button";
import Modal from "../Modal/Modal";
import DocumentViewer from "../Common/DocumentViewer";
import { ENDPOINTS } from "../../redux/apiConfig";
import axios from "axios";
import { Link } from "react-router-dom";
import { showToast } from "../Toast/Toast";
const DocumentsList = ({
  data = [],
  downloadFun = 1,
  viewFun = 1,
  newTab = true,
  type = "modal", //modal, inner
  useAtsBackend = false, // Added prop
  useBenchSalesBackend = false, // Added prop
}) => {
  const [selectedData, setSelectedData] = useState("");
  const [viewModal, setViewModal] = useState(false);
  const [awsUrl, setAwsUrl] = useState("");
  const fetchUrl = async (s3Key, isWorkforce = false) => {
    try {
      let endpoint = "";
      if (useAtsBackend) {
        endpoint = `${ENDPOINTS.ATS_UNIVERSAL.GET_S3_LINK}&key=${s3Key}${isWorkforce ? "&workforce_upload=true" : ""}`;
      } else if (useBenchSalesBackend) {
        endpoint = `${ENDPOINTS.BS_UNIVERSAL.GET_S3_LINK}&key=${s3Key}${isWorkforce ? "&workforce_upload=true" : ""}`;
      } else {
        endpoint = `${ENDPOINTS.UNIVERSAL.GET_S3_LINK}&key=${s3Key}`;
      }
      const res = await axios.get(endpoint, { withCredentials: true });
      return res.data.data?.url || res.data.data;
    } catch (err) {
      console.error("fetchUrl error:", err);
      return "";
    }
  };
  const handleClickViewModal = async (data) => {
    setAwsUrl("");
    const url = await fetchUrl(data.filePath, data.isWorkforce || data.workforce_upload);
    setSelectedData(data);
    setViewModal(true);
    setAwsUrl(url);
  };
  const downloadFile = async (data, fileName = "downloaded-file") => {
    try {
      const url = data.filePath || data;
      const isWorkforce = data.isWorkforce || data.workforce_upload;
      const urlData = await fetchUrl(url, isWorkforce);
      const response = await fetch(urlData, {
        mode: "cors",
      });

      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
      const blob = await response.blob();
      const link = document.createElement("a");
      const objectUrl = URL.createObjectURL(blob);
      link.href = objectUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Clean up blob URL
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error("Download error:", error);
    }
  };
  const openFileInNewTab = async (data, tabName = "New Tab") => {
    try {
      const url = data.filePath || data;
      const isWorkforce = data.isWorkforce || data.workforce_upload;
      const urlData = await fetchUrl(url, isWorkforce);
      console.log({urlData});
      if (!urlData) {
        showToast("Failed to Open file", "error");
        throw new Error(`Link is invalid or not found, Link looks like :: ${urlData}`);
      }
      window.open(urlData, tabName);
    } catch (error) {
      console.error("Open file in new tab error:", error);
    }
  };

  const renderDocumentItem = (doc, index) => {
    switch (type) {
      case "inner":
        return (
          <div
            key={index}
            className="flex justify-between gap-2 items-center py-0 pl-4 pr-1 mt-3  bg-info-50 rounded-md"
          >
            <div className="text-sm">{doc?.name || "Attachment"}</div>
            <div className="flex items-center gap-0">
              {downloadFun && doc?.filePath && (
                <Button
                  type="icon"
                  color="dark"
                  variant="text"
                  size="sm"
                  icon="download"
                  onClick={() => downloadFile(doc, doc?.name)}
                />
              )}
              {viewFun && doc?.filePath && (
                <Button
                  type="icon"
                  color="dark"
                  variant="text"
                  size="sm"
                  icon="visibility"
                  onClick={() => handleClickViewModal(doc)}
                />
              )}
              {newTab && doc?.filePath && (
                <Button
                  type="link"
                  color="dark"
                  variant="text"
                  size="sm"
                  icon={"open_in_new"}
                  onClick={() => openFileInNewTab(doc)}
                  className="!px-0 !mx-1"
                />
              )}
            </div>
          </div>
        );
      case "modal":
      default:
        return (
          <div key={index} className="flex justify-between items-center">
            <div className="flex items-center gap-3">
              <span className="material-symbols-rounded font-light text-3xl text-primary">
                description
              </span>
              <h6 className="line-clamp-1 font-normal">
                {doc?.name || "Attachment"}
              </h6>
            </div>
            <div className="flex items-center gap-0.5">
              {downloadFun && doc?.filePath && (
                <Button
                  type="icon"
                  color="dark"
                  variant="text"
                  icon="download"
                  onClick={() => downloadFile(doc, doc?.name)}
                />
              )}

              {viewFun && doc?.filePath && (
                <Button
                  type="icon"
                  color="dark"
                  variant="text"
                  icon="visibility"
                  onClick={() => handleClickViewModal(doc)}
                />
              )}
              {newTab && doc?.filePath && (
                <Button
                  type="link"
                  color="dark"
                  variant="text"
                  icon={"open_in_new"}
                  onClick={() => openFileInNewTab(doc)}
                  className="!px-1 ml-0"
                />
              )}
            </div>
          </div>
        );
    }
  };

  return (
    <div
      className={`flex gap-2 ${type === "modal" ? "flex-col " : "flex-row"}`}
    >
      {data.map((doc, index) => renderDocumentItem(doc, index))}

      <Modal
        width="max-w-6xl"
        title={selectedData?.name || "Document Details"}
        isOpen={viewModal}
        onClose={() => setViewModal(false)}
      >
        <DocumentViewer AwsResumeUrl={awsUrl || ""} />
      </Modal>
    </div>
  );
};

export default DocumentsList;
